import { render, staticRenderFns } from "./CrmUserTargets.vue?vue&type=template&id=ef1978f8&"
import script from "./CrmUserTargets.vue?vue&type=script&lang=js&"
export * from "./CrmUserTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports